export const formatNumberWithSuffix = (value: number): string => {
  if (value >= 1000000) {
    return `${(value / 1000000).toFixed(0)}M`;
  } else if (value >= 1000) {
    return `${(value / 1000).toFixed(0)}K`;
  }

  return value.toFixed(0);
};

export const formatPlanQuotaCompact = (value: number): string => {
  if (!Number.isFinite(value) || value < 0) {
    return String(value);
  }
  if (value >= 1_000_000) {
    const scaled = Math.round((value / 1_000_000) * 10) / 10;
    if (Number.isInteger(scaled)) {
      return `${scaled}M`;
    }
    return `${scaled.toFixed(1)}M`;
  }
  if (value >= 1_000) {
    const scaled = Math.round((value / 1_000) * 10) / 10;
    if (Number.isInteger(scaled)) {
      return `${scaled}K`;
    }
    return `${scaled.toFixed(1)}K`;
  }
  return value.toLocaleString();
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isChartDataEmpty = (chartData: any[]): boolean => {
  if (!chartData || chartData.length === 0) {
    return true;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return chartData.every((point: any) => {
    const workspaceValues = Object.keys(point)
      .filter(key => key !== "datetime" && key !== "rawDatetime" && key !== "isProjected")
      .map(key => point[key] || 0);

    return workspaceValues.length === 0 || workspaceValues.every(value => value === 0);
  });
};

export const calculateProjectedOveragePrice = (
  totalUsage: number | null | undefined,
  adjustedLimit: number | string | undefined,
  overageRate: number | null | undefined,
): number =>
  ((totalUsage || 0) - (typeof adjustedLimit === "number" ? adjustedLimit : 0)) *
  (overageRate || 0);

export const shouldShowLimitLine = (
  chartType: "cumulative" | "periodic",
  usageType: string,
): boolean =>
  (chartType === "cumulative" && usageType !== "playgroundRuns") ||
  (chartType === "periodic" && usageType === "playgroundRuns");
